import Routes from './routes/routes'
import { ToastContainer } from 'react-toastify'
import 'react-tooltip/dist/react-tooltip.css'
import 'react-toastify/dist/ReactToastify.css'
import { ThemeProvider } from 'styled-components'
import { GlobalStyle } from './styles/global'
import { IconContext } from 'react-icons'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { api } from './services/api'
import React from 'react'
import { useConfigStore } from './store/config'
import { theme } from './styles/theme'
import Modal from 'react-modal'

const queryClient = new QueryClient()

function App() {
  const setConfig = useConfigStore.getState().setConfig
  const config = useConfigStore().config

  const [themeDefault, seThemeDefault] = React.useState(theme)

  const getConfig = async () => {
    const { data: response } = await api.get(`/config`)
    setConfig(response)
  }

  React.useEffect(() => {
    getConfig()
    // Configurar o elemento app para o react-modal
    Modal.setAppElement('#root')
  }, [])

  React.useEffect(() => {
    if (config) {
      let theme = themeDefault
      theme.colors.primary = config?.primaryColor || '#424242'
      theme.colors.secondary = config?.secondaryColor || '#E6E6E6'
      theme.colors.text = config?.primaryColor || '#424242'
      theme.colors.border = config?.primaryColor || '#424242'
      theme.colors.input = config?.primaryColor || '#424242'
      theme.colors.label = config?.primaryColor || '#424242'
      theme.colors.title = config?.primaryColor || '#424242'
      theme.colors.header = config?.secondaryColor || '#E6E6E6'
      theme.colors.drawer = config?.secondaryColor || '#E6E6E6'

      seThemeDefault(theme)
    }
  }, [config])

  return (
    <>
      <ToastContainer />
      <QueryClientProvider client={queryClient}>
        <IconContext.Provider value={{ color: config?.primaryColor }}>
          <ThemeProvider theme={themeDefault}>
            <GlobalStyle />
            <Routes />
            
          </ThemeProvider>
        </IconContext.Provider>
      </QueryClientProvider>
    </>
  )
}

export default App
